import Button from '../../Button'
import {MenubarNameViewProps} from './types'
import React from 'react'
import UserAvatar from '../../Avatar/UserAvatar'
import {styled} from '../../../stitches/config'
import {useTranslation} from 'react-i18next'

const StyledChannelName = styled('div', {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    minWidth: '80px',
    overflowX: 'hidden',
    width: 0,
})

const MenubarNameView = (props: MenubarNameViewProps): React.ReactElement => {
    const {
        isChannelSidebarOpen,
        onToggleChannelSidebar,
        ...avatarProps
    } = props

    const {t} = useTranslation()

    return (
        <StyledChannelName>
            <Button
                avatar={UserAvatar}
                avatarProps={avatarProps}
                color='text'
                onPress={onToggleChannelSidebar}
                text={avatarProps.name}
                title={isChannelSidebarOpen ? t('Hide channel info') : t('Show channel info')}
            />
        </StyledChannelName>
    )
}

export default MenubarNameView
